<template>
  <div class="teacher-page" :class="{ 'd-flex': !embedded, 'question-manage-embedded': embedded }">
    <aside v-if="!embedded" class="side-nav" :class="{ collapsed: sidebarCollapsed }">
      <div class="side-head">
        <h4 class="mb-0" v-show="!sidebarCollapsed">教师端</h4>
        <button class="collapse-btn" @click="toggleSidebar">{{ sidebarCollapsed ? '>>' : '<<' }}</button>
      </div>
      <button class="sub-btn active"><span class="nav-text">题库管理</span></button>
      <button class="sub-btn" @click="goPaperManage"><span class="nav-text">试卷管理</span></button>
      <button class="sub-btn" @click="goExamManage"><span class="nav-text">考试管理</span></button>
      <button class="sub-btn" @click="goGradingManage"><span class="nav-text">阅卷管理</span></button>
      <button class="sub-btn" @click="goExamRecordManage"><span class="nav-text">考生试卷管理</span></button>
      <button class="sub-btn" @click="goProctor"><span class="nav-text">监考系统</span></button>
      <button class="sub-btn" @click="goStudentUsers"><span class="nav-text">学生用户管理</span></button>
      <div class="mt-auto">
        <button class="btn btn-sm btn-light w-100 mb-2" @click="logout">退出登录</button>
      </div>
    </aside>

    <main class="content-area" :class="{ 'question-manage-embedded-main': embedded }">
      <header class="topbar">
        <h2>{{ pageTitle }}</h2>
        <div class="actions">
          <button class="btn btn-sm btn-success" @click="loadAll">刷新数据</button>
        </div>
      </header>

    <section class="card-box">
      <h4>题库分类管理</h4>
      <p class="small text-muted mb-2" v-if="!isAdmin">教师仅可管理自己创建的公开题库；私密题库仅管理员可见。</p>
      <p class="small text-muted mb-2" v-else>管理员可查看全部题库，并可设置「私密」使教师无法查看与组卷使用。</p>
      <div class="row g-2 mb-3 align-items-end">
        <div class="col-md-4">
          <input v-model="bankForm.bankName" class="form-control" placeholder="题库名称" />
        </div>
        <div class="col-md-2">
          <input v-model.number="bankForm.sort" type="number" class="form-control" placeholder="排序" />
        </div>
        <div class="col-md-2" v-if="isAdmin">
          <select v-model.number="bankForm.isPrivate" class="form-select">
            <option :value="0">公开</option>
            <option :value="1">私密</option>
          </select>
        </div>
        <div class="col-md-2">
          <button class="btn btn-success w-100" @click="saveBank">保存题库</button>
        </div>
      </div>
      <ul class="list-group">
        <li class="list-group-item d-flex justify-content-between align-items-center" v-for="b in banks" :key="b.id">
          <span>
            {{ b.bankName }}（排序：{{ b.sort || 0 }}）
            <span v-if="Number(b.isPrivate) === 1" class="badge bg-warning text-dark ms-2">私密</span>
            <span v-else class="badge bg-light text-secondary ms-2">公开</span>
            <span v-if="isAdmin" class="small text-muted ms-2">创建人：{{ b.creatorName || ('ID:' + (b.creatorId || '-')) }}</span>
          </span>
          <div class="d-flex gap-2">
            <button
              v-if="isAdmin"
              class="btn btn-sm btn-outline-secondary"
              type="button"
              @click="toggleBankPrivate(b)"
            >{{ Number(b.isPrivate) === 1 ? '设为公开' : '设为私密' }}</button>
            <button class="btn btn-sm btn-danger" type="button" @click="deleteBank(b.id)">删除</button>
          </div>
        </li>
      </ul>
    </section>

    <section class="card-box">
      <h4>标签管理</h4>
      <div class="row g-2 mb-3">
        <div class="col-md-4">
          <input v-model="tagForm.tagName" class="form-control" placeholder="标签名称" />
        </div>
        <div class="col-md-2">
          <button class="btn btn-success w-100" @click="saveTag">保存标签</button>
        </div>
      </div>
      <div class="d-flex flex-wrap gap-2">
        <span class="badge bg-success" v-for="t in tags" :key="t.id">
          {{ t.tagName }}
          <button class="btn-close btn-close-white ms-2 mini-close" @click="deleteTag(t.id)"></button>
        </span>
      </div>
    </section>

    <section class="card-box">
      <h4>题目管理</h4>
      <div class="row g-2">
        <div class="col-md-3">
          <select v-model.number="questionForm.bankId" class="form-select">
            <option :value="null">选择题库</option>
            <option v-for="b in banks" :key="b.id" :value="b.id">{{ b.bankName }}</option>
          </select>
        </div>
        <div class="col-md-2">
          <select v-model="questionForm.type" class="form-select" @change="onQuestionTypeChange">
            <option value="radio">单选</option>
            <option value="multiple">多选</option>
            <option value="judge">判断</option>
            <option value="fill">填空</option>
            <option value="essay">简答</option>
            <option value="coding">编程题</option>
            <option value="material_collect">资料收集题</option>
            <option value="scratch">Scratch编程题</option>
          </select>
        </div>
        <div class="col-md-2">
          <select v-model="questionForm.difficulty" class="form-select">
            <option value="easy">易</option>
            <option value="middle">中</option>
            <option value="hard">难</option>
          </select>
        </div>
        <div class="col-md-2">
          <input v-model.number="questionForm.score" type="number" class="form-control" placeholder="分值" />
        </div>
      </div>

      <div class="mt-2">
        <textarea v-model="questionForm.title" class="form-control mb-2" rows="5" placeholder="题干（支持换行，与学生端展示一致）"></textarea>
        <div class="mb-3 qimg-block rounded p-2" style="background: rgba(255,255,255,0.55); border: 1px solid #dfe9ff;">
          <div class="d-flex align-items-center gap-2 flex-wrap mb-2">
            <span class="form-label mb-0 fw-semibold">题干附图</span>
            <label class="btn btn-sm btn-outline-secondary mb-0">
              上传图片
              <input type="file" class="d-none" accept=".jpg,.jpeg,.png,.gif,image/*" @change="onTeacherUploadStem" />
            </label>
            <span class="small text-muted">jpg/png/gif，≤5MB，支持多张</span>
          </div>
          <div class="d-flex flex-wrap gap-2 align-items-start">
            <div v-for="(u, idx) in questionForm.contentImages" :key="'stem-img-' + idx" class="qimg-tile text-center">
              <img :src="u" class="teacher-q-thumb" alt="" @click="teachImgLightboxUrl = u" />
              <div>
                <button type="button" class="btn btn-link btn-sm p-0 text-danger" @click="questionForm.contentImages.splice(idx, 1)">
                  移除
                </button>
              </div>
            </div>
          </div>
        </div>

        <div v-if="questionForm.type === 'radio'" class="mb-2">
          <label class="form-label">单选题选项A</label>
          <textarea v-model="questionSingleOptions.A" class="form-control mb-2" rows="2" placeholder="请输入选项A"></textarea>
          <div class="d-flex align-items-center gap-2 flex-wrap mb-2">
            <label class="btn btn-sm btn-outline-secondary mb-0">选项A附图<input type="file" class="d-none" accept=".jpg,.jpeg,.png,.gif,image/*" @change="(e)=>onTeacherOptImg(e,'A')" /></label>
            <template v-if="questionForm.optionAImage">
              <img :src="questionForm.optionAImage" class="teacher-q-thumb" alt="" @click="teachImgLightboxUrl = questionForm.optionAImage" />
              <button type="button" class="btn btn-link btn-sm p-0 text-danger" @click="questionForm.optionAImage = ''">清除</button>
            </template>
          </div>
          <label class="form-label">单选题选项B</label>
          <textarea v-model="questionSingleOptions.B" class="form-control mb-2" rows="2" placeholder="请输入选项B"></textarea>
          <div class="d-flex align-items-center gap-2 flex-wrap mb-2">
            <label class="btn btn-sm btn-outline-secondary mb-0">选项B附图<input type="file" class="d-none" accept=".jpg,.jpeg,.png,.gif,image/*" @change="(e)=>onTeacherOptImg(e,'B')" /></label>
            <template v-if="questionForm.optionBImage">
              <img :src="questionForm.optionBImage" class="teacher-q-thumb" alt="" @click="teachImgLightboxUrl = questionForm.optionBImage" />
              <button type="button" class="btn btn-link btn-sm p-0 text-danger" @click="questionForm.optionBImage = ''">清除</button>
            </template>
          </div>
          <label class="form-label">单选题选项C</label>
          <textarea v-model="questionSingleOptions.C" class="form-control mb-2" rows="2" placeholder="请输入选项C"></textarea>
          <div class="d-flex align-items-center gap-2 flex-wrap mb-2">
            <label class="btn btn-sm btn-outline-secondary mb-0">选项C附图<input type="file" class="d-none" accept=".jpg,.jpeg,.png,.gif,image/*" @change="(e)=>onTeacherOptImg(e,'C')" /></label>
            <template v-if="questionForm.optionCImage">
              <img :src="questionForm.optionCImage" class="teacher-q-thumb" alt="" @click="teachImgLightboxUrl = questionForm.optionCImage" />
              <button type="button" class="btn btn-link btn-sm p-0 text-danger" @click="questionForm.optionCImage = ''">清除</button>
            </template>
          </div>
          <label class="form-label">单选题选项D</label>
          <textarea v-model="questionSingleOptions.D" class="form-control mb-2" rows="2" placeholder="请输入选项D"></textarea>
          <div class="d-flex align-items-center gap-2 flex-wrap mb-2">
            <label class="btn btn-sm btn-outline-secondary mb-0">选项D附图<input type="file" class="d-none" accept=".jpg,.jpeg,.png,.gif,image/*" @change="(e)=>onTeacherOptImg(e,'D')" /></label>
            <template v-if="questionForm.optionDImage">
              <img :src="questionForm.optionDImage" class="teacher-q-thumb" alt="" @click="teachImgLightboxUrl = questionForm.optionDImage" />
              <button type="button" class="btn btn-link btn-sm p-0 text-danger" @click="questionForm.optionDImage = ''">清除</button>
            </template>
          </div>
          <label class="form-label">正确答案</label>
          <select v-model="questionSingleAnswer" class="form-select mb-2">
            <option value="A">A</option>
            <option value="B">B</option>
            <option value="C">C</option>
            <option value="D">D</option>
          </select>
        </div>
        <div v-else-if="questionForm.type === 'multiple'" class="mb-2">
          <label class="form-label">多选题选项A</label>
          <textarea v-model="questionSingleOptions.A" class="form-control mb-2" rows="2" placeholder="请输入选项A"></textarea>
          <div class="d-flex align-items-center gap-2 flex-wrap mb-2">
            <label class="btn btn-sm btn-outline-secondary mb-0">选项A附图<input type="file" class="d-none" accept=".jpg,.jpeg,.png,.gif,image/*" @change="(e)=>onTeacherOptImg(e,'A')" /></label>
            <template v-if="questionForm.optionAImage">
              <img :src="questionForm.optionAImage" class="teacher-q-thumb" alt="" @click="teachImgLightboxUrl = questionForm.optionAImage" />
              <button type="button" class="btn btn-link btn-sm p-0 text-danger" @click="questionForm.optionAImage = ''">清除</button>
            </template>
          </div>
          <label class="form-label">多选题选项B</label>
          <textarea v-model="questionSingleOptions.B" class="form-control mb-2" rows="2" placeholder="请输入选项B"></textarea>
          <div class="d-flex align-items-center gap-2 flex-wrap mb-2">
            <label class="btn btn-sm btn-outline-secondary mb-0">选项B附图<input type="file" class="d-none" accept=".jpg,.jpeg,.png,.gif,image/*" @change="(e)=>onTeacherOptImg(e,'B')" /></label>
            <template v-if="questionForm.optionBImage">
              <img :src="questionForm.optionBImage" class="teacher-q-thumb" alt="" @click="teachImgLightboxUrl = questionForm.optionBImage" />
              <button type="button" class="btn btn-link btn-sm p-0 text-danger" @click="questionForm.optionBImage = ''">清除</button>
            </template>
          </div>
          <label class="form-label">多选题选项C</label>
          <textarea v-model="questionSingleOptions.C" class="form-control mb-2" rows="2" placeholder="请输入选项C"></textarea>
          <div class="d-flex align-items-center gap-2 flex-wrap mb-2">
            <label class="btn btn-sm btn-outline-secondary mb-0">选项C附图<input type="file" class="d-none" accept=".jpg,.jpeg,.png,.gif,image/*" @change="(e)=>onTeacherOptImg(e,'C')" /></label>
            <template v-if="questionForm.optionCImage">
              <img :src="questionForm.optionCImage" class="teacher-q-thumb" alt="" @click="teachImgLightboxUrl = questionForm.optionCImage" />
              <button type="button" class="btn btn-link btn-sm p-0 text-danger" @click="questionForm.optionCImage = ''">清除</button>
            </template>
          </div>
          <label class="form-label">多选题选项D</label>
          <textarea v-model="questionSingleOptions.D" class="form-control mb-2" rows="2" placeholder="请输入选项D"></textarea>
          <div class="d-flex align-items-center gap-2 flex-wrap mb-2">
            <label class="btn btn-sm btn-outline-secondary mb-0">选项D附图<input type="file" class="d-none" accept=".jpg,.jpeg,.png,.gif,image/*" @change="(e)=>onTeacherOptImg(e,'D')" /></label>
            <template v-if="questionForm.optionDImage">
              <img :src="questionForm.optionDImage" class="teacher-q-thumb" alt="" @click="teachImgLightboxUrl = questionForm.optionDImage" />
              <button type="button" class="btn btn-link btn-sm p-0 text-danger" @click="questionForm.optionDImage = ''">清除</button>
            </template>
          </div>
          <label class="form-label">正确答案（可多选）</label>
          <div class="d-flex gap-3 mb-2">
            <label class="form-check-label"><input v-model="questionMultipleAnswers" class="form-check-input me-1" type="checkbox" value="A" />A</label>
            <label class="form-check-label"><input v-model="questionMultipleAnswers" class="form-check-input me-1" type="checkbox" value="B" />B</label>
            <label class="form-check-label"><input v-model="questionMultipleAnswers" class="form-check-input me-1" type="checkbox" value="C" />C</label>
            <label class="form-check-label"><input v-model="questionMultipleAnswers" class="form-check-input me-1" type="checkbox" value="D" />D</label>
          </div>
        </div>
        <div v-else-if="questionForm.type === 'coding'" class="mb-2">
          <label class="form-label">参考答案（参考解代码，用于校验用例）</label>
          <textarea v-model="questionForm.answer" class="form-control mb-2 font-monospace" rows="5" placeholder="请输入可通过全部测试用例的参考 Python 代码"></textarea>
          <CodingTestCaseEditor
            v-model="codingFormConfig"
            :reference-code="questionForm.answer"
            :validating="codingValidateBusy"
            :validate-message="codingValidateMessage"
            :validate-ok="codingValidateOk"
            @validate="validateCodingCases(false)"
          />
        </div>
        <div v-else-if="questionForm.type === 'fill'" class="mb-2">
          <label class="form-label">填空题参考答案</label>
          <textarea v-model="questionForm.answer" class="form-control mb-2" rows="3" placeholder="多个空请用 || 分隔，如：光合作用||叶绿体"></textarea>
          <label class="form-label">填空判分说明（可选）</label>
          <textarea v-model="questionForm.options" class="form-control mb-2" rows="2" placeholder="可填写同义词、大小写规则、关键字匹配规则"></textarea>
        </div>
        <div v-else-if="questionForm.type === 'essay'" class="mb-2">
          <label class="form-label">简答题参考要点</label>
          <textarea v-model="questionForm.answer" class="form-control mb-2" rows="4" placeholder="请输入采分点，如：定义、原因、举例"></textarea>
          <label class="form-label">简答评分标准（可选）</label>
          <textarea v-model="questionForm.options" class="form-control mb-2" rows="3" placeholder="可填写分档标准，例如：答对2点得满分，答对1点得一半分"></textarea>
        </div>
        <div v-else-if="questionForm.type === 'material_collect'" class="mb-2">
          <label class="form-label">允许学生上传附件的最大数量</label>
          <input v-model.number="materialMaxAttachments" type="number" min="1" :max="MATERIAL_MAX_ATTACHMENT_COUNT" class="form-control mb-2" />
          <p class="small text-muted mb-0">
            学生交卷时必须填写文字说明，且上传附件数量<strong>恰好等于</strong>此处设置的数量。单个附件不超过 10MB；允许格式：jpg/png/jpeg/gif、pdf、word(doc/docx)、zip、rar。
          </p>
        </div>
        <div v-else-if="questionForm.type === 'scratch'" class="mb-2">
          <p class="small text-muted mb-2">
            题干为题目说明；下方「解析」字段请填写<strong>任务要求</strong>（学生端展示）。学生使用内嵌 Scratch 3 编辑器作答，交卷前须成功上传 .sb3（≤10MB）。
          </p>
          <div class="form-check mb-1">
            <input id="sc-sprite" v-model="scratchAllowNewSprites" class="form-check-input" type="checkbox" />
            <label class="form-check-label" for="sc-sprite">允许学生新增角色</label>
          </div>
          <div class="form-check mb-1">
            <input id="sc-back" v-model="scratchAllowNewBackdrops" class="form-check-input" type="checkbox" />
            <label class="form-check-label" for="sc-back">允许学生新增背景</label>
          </div>
          <div class="form-check mb-1">
            <input id="sc-lib" v-model="scratchAllowMaterialsLibrary" class="form-check-input" type="checkbox" />
            <label class="form-check-label" for="sc-lib">允许使用素材库（角色/背景库等）</label>
          </div>
          <div class="form-check mb-0">
            <input id="sc-empty" v-model="scratchEmptyProjectDefault" class="form-check-input" type="checkbox" />
            <label class="form-check-label" for="sc-empty">默认加载空项目</label>
          </div>
        </div>
        <div v-else>
          <textarea v-model="questionForm.options" class="form-control mb-2" rows="2" placeholder="选项JSON（可空）"></textarea>
          <textarea v-model="questionForm.answer" class="form-control mb-2" rows="2" placeholder="答案"></textarea>
        </div>
        <label class="form-label mb-1">{{ questionForm.type === 'scratch' ? '任务要求' : '解析' }}</label>
        <textarea
          v-model="questionForm.analysis"
          class="form-control mb-2"
          rows="2"
          :placeholder="questionForm.type === 'scratch' ? '任务要求（学生端展示）' : '解析'"
        />
        <div class="mb-3 qimg-block rounded p-2" style="background: rgba(255,255,255,0.55); border: 1px solid #dfe9ff;">
          <div class="d-flex align-items-center gap-2 flex-wrap mb-2">
            <span class="form-label mb-0 fw-semibold">解析附图</span>
            <label class="btn btn-sm btn-outline-secondary mb-0">
              上传图片
              <input type="file" class="d-none" accept=".jpg,.jpeg,.png,.gif,image/*" @change="onTeacherUploadAnalysis" />
            </label>
          </div>
          <div class="d-flex flex-wrap gap-2 align-items-start">
            <div v-for="(u, j) in questionForm.analysisImages" :key="'ana-img-' + j" class="qimg-tile text-center">
              <img :src="u" class="teacher-q-thumb" alt="" @click="teachImgLightboxUrl = u" />
              <div>
                <button type="button" class="btn btn-link btn-sm p-0 text-danger" @click="questionForm.analysisImages.splice(j, 1)">
                  移除
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mb-2">
        <label class="form-label">标签</label>
        <div class="d-flex flex-wrap gap-2">
          <label class="badge bg-secondary p-2" v-for="t in tags" :key="t.id">
            <input type="checkbox" class="form-check-input me-1" :value="t.id" v-model="questionForm.tagIds" />
            {{ t.tagName }}
          </label>
        </div>
      </div>

      <div class="d-flex gap-2 mb-3">
        <button class="btn btn-success" @click="saveQuestion">保存题目</button>
        <button class="btn btn-warning" @click="resetQuestionForm">重置表单</button>
        <button class="btn btn-primary" @click="exportExcel">导出Excel</button>
        <button class="btn btn-primary" @click="downloadImportTemplate">下载导入模板</button>
        <span class="small text-muted align-self-center">（编程题请用此模板，见模板内示例行）</span>
        <button class="btn btn-primary" @click="downloadEmbeddedExcelTemplate">下载嵌入式图片题库模板</button>
        <label class="btn btn-primary mb-0">
          导入Excel
          <input type="file" hidden accept=".xlsx" @change="importExcel" />
        </label>
      </div>

      <div class="card-box mt-3" style="border-style: dashed">
        <h5 class="h6 fw-bold">批量导入 · Excel（单元格内嵌图片）</h5>
        <p class="small text-muted mb-2">
          下载模板后，在 <strong>A～L 列</strong>填写题型与文字（含难度 / 分值 / 标签）；在题干、选项、解析对应单元格配图时请使用 Excel「插入 → 图片」，并选择<strong>「放置在单元格上方」</strong>浮动图片（支持同一单元格多张图）。
          <strong>不要使用「放置在单元格中」</strong>（Excel 365 会写入 DISPIMG 公式，系统无法提取图片，编辑题目会只看到公式文本）。
          仅需上传 <strong>一个 .xlsx</strong>，无需压缩包。题型支持：<strong>单选 / 多选 / 判断 / 编程题</strong>（编程题：G=参考代码，I=判题JSON，C~F留空；J=难度，K=分值，L=标签）。
        </p>
        <div class="d-flex flex-wrap gap-2 mb-2 align-items-center">
          <button type="button" class="btn btn-sm btn-outline-primary" @click="downloadEmbeddedExcelTemplate">下载嵌入式图片模板</button>
          <label class="btn btn-sm btn-primary mb-0">
            选择 Excel 并导入
            <input type="file" hidden accept=".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" @change="submitEmbeddedExcelImport" />
          </label>
        </div>
        <div v-if="embeddedImportBusy || embeddedImportProgress" class="alert alert-info py-2 mb-2 small">
          {{ embeddedImportProgress || '处理中…' }}
        </div>
        <div v-if="batchImportResult" class="result-shell mt-2 p-2">
          <div class="small mb-1">
            成功 {{ batchImportResult.successCount }} 条 · 失败 {{ batchImportResult.failCount }} 条
            <span v-if="Number(batchImportResult.extractedImageCount) > 0" class="ms-1">· 已提取并上传图片 {{ batchImportResult.extractedImageCount }} 张</span>
          </div>
          <div class="table-responsive" style="max-height: 220px">
            <table class="table table-sm table-striped mb-0">
              <thead><tr><th>Excel行</th><th>列</th><th>原因</th></tr></thead>
              <tbody>
                <tr v-for="(f, i) in (batchImportResult.failures || [])" :key="'bf-' + i">
                  <td>{{ f.excelRowNumber }}</td>
                  <td>{{ f.column }}</td>
                  <td>{{ f.reason }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="card-box mt-3" style="border-style: dashed">
        <h5 class="h6 fw-bold">批量导入 · Excel + ZIP 图片包</h5>
        <p class="small text-muted mb-2">
          下载模板后填写 Excel，并将图片文件<strong>扁平</strong>放入 ZIP（不要子目录）。题干/选项/解析单元格可用<code>|文件名.png</code>引用 ZIP 内图片。
          支持<strong>单选 / 多选 / 判断 / 编程题</strong>（编程题填「判题JSON」列，参考代码填「正确答案」列）。
        </p>
        <div class="d-flex flex-wrap gap-2 mb-2 align-items-center">
          <button type="button" class="btn btn-sm btn-outline-primary" @click="downloadImageZipTemplate">下载 Excel+ZIP 模板</button>
          <label class="btn btn-sm btn-outline-secondary mb-0">
            选择 Excel
            <input type="file" hidden accept=".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" @change="onZipImportExcelPick" />
          </label>
          <label class="btn btn-sm btn-outline-secondary mb-0">
            选择 ZIP
            <input type="file" hidden accept=".zip,application/zip" @change="onZipImportZipPick" />
          </label>
          <button type="button" class="btn btn-sm btn-primary" :disabled="zipImportBusy || !zipImportExcel || !zipImportZip" @click="submitZipImport">
            开始导入
          </button>
          <span v-if="zipImportExcel" class="small text-muted">Excel: {{ zipImportExcel.name }}</span>
          <span v-if="zipImportZip" class="small text-muted">ZIP: {{ zipImportZip.name }}</span>
        </div>
        <div v-if="zipImportBusy || zipImportProgress" class="alert alert-info py-2 mb-2 small">
          {{ zipImportProgress || '处理中…' }}
        </div>
      </div>

      <div class="result-shell">
        <div class="row g-2 align-items-end mb-3 question-filter-bar">
          <div class="col-md-3">
            <label class="form-label mb-1 small text-muted">题干关键词</label>
            <input
              v-model.trim="questionFilters.keyword"
              class="form-control form-control-sm"
              placeholder="模糊搜索题干"
              @keyup.enter="searchQuestions"
            />
          </div>
          <div class="col-md-2">
            <label class="form-label mb-1 small text-muted">题型</label>
            <select v-model="questionFilters.type" class="form-select form-select-sm">
              <option value="">全部题型</option>
              <option value="radio">单选</option>
              <option value="multiple">多选</option>
              <option value="judge">判断</option>
              <option value="fill">填空</option>
              <option value="essay">简答</option>
              <option value="coding">编程题</option>
              <option value="material_collect">资料收集题</option>
              <option value="scratch">Scratch编程题</option>
            </select>
          </div>
          <div class="col-md-2">
            <label class="form-label mb-1 small text-muted">难度</label>
            <select v-model="questionFilters.difficulty" class="form-select form-select-sm">
              <option value="">全部难度</option>
              <option value="easy">简单</option>
              <option value="middle">中等</option>
              <option value="hard">困难</option>
            </select>
          </div>
          <div class="col-md-2">
            <label class="form-label mb-1 small text-muted">题库</label>
            <select v-model="questionFilters.bankId" class="form-select form-select-sm">
              <option value="">全部题库</option>
              <option v-for="b in banks" :key="'qf-bank-' + b.id" :value="String(b.id)">{{ b.bankName }}</option>
            </select>
          </div>
          <div class="col-md-2">
            <label class="form-label mb-1 small text-muted">标签</label>
            <select v-model="questionFilters.tagId" class="form-select form-select-sm">
              <option value="">全部标签</option>
              <option v-for="t in tags" :key="'qf-tag-' + t.id" :value="String(t.id)">{{ t.tagName }}</option>
            </select>
          </div>
          <div class="col-md-2" v-if="isAdmin">
            <label class="form-label mb-1 small text-muted">创建人</label>
            <select v-model="questionFilters.creatorId" class="form-select form-select-sm">
              <option value="">全部创建人</option>
              <option v-for="c in bankCreators" :key="'qf-creator-' + c.id" :value="String(c.id)">{{ c.displayName || c.username }}</option>
            </select>
          </div>
          <div class="col-md-2" v-if="isAdmin">
            <label class="form-label mb-1 small text-muted">是否私密题库</label>
            <select v-model="questionFilters.isPrivate" class="form-select form-select-sm">
              <option value="">全部</option>
              <option value="0">公开</option>
              <option value="1">私密</option>
            </select>
          </div>
          <div class="col-md-1">
            <label class="form-label mb-1 small text-muted">每页</label>
            <select v-model.number="questionPageSize" class="form-select form-select-sm" @change="searchQuestions">
              <option :value="10">10</option>
              <option :value="20">20</option>
              <option :value="50">50</option>
            </select>
          </div>
          <div class="col-12 d-flex flex-wrap gap-2">
            <button type="button" class="btn btn-sm btn-primary" @click="searchQuestions">查询</button>
            <button type="button" class="btn btn-sm btn-light" @click="resetQuestionFilters">重置</button>
            <button
              type="button"
              class="btn btn-sm btn-danger"
              :disabled="selectedQuestionIds.length === 0 || questionLoading || batchDeleting"
              @click="batchDeleteQuestions"
            >
              批量删除{{ selectedQuestionIds.length ? `（${selectedQuestionIds.length}）` : '' }}
            </button>
            <span class="small text-muted align-self-center">
              共 {{ questionTotalElements }} 条，第 {{ questionPage + 1 }} / {{ questionTotalPages }} 页
            </span>
          </div>
        </div>
        <table class="table table-striped align-middle modern-table mb-0">
          <thead>
            <tr>
              <th style="width: 42px">
                <input
                  type="checkbox"
                  class="form-check-input"
                  :checked="allCurrentPageSelected"
                  :indeterminate.prop="someCurrentPageSelected && !allCurrentPageSelected"
                  :disabled="questions.length === 0 || questionLoading"
                  @change="toggleSelectAllCurrentPage($event.target.checked)"
                  title="全选本页"
                />
              </th>
              <th>ID</th>
              <th>题型</th>
              <th>难度</th>
              <th>分值</th>
              <th>题干</th>
              <th v-if="isAdmin">题库</th>
              <th v-if="isAdmin">创建人</th>
              <th v-if="isAdmin">私密</th>
              <th>标签</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in questions" :key="item.question.id">
              <td>
                <input
                  type="checkbox"
                  class="form-check-input"
                  :value="item.question.id"
                  :checked="selectedQuestionIds.includes(Number(item.question.id))"
                  @change="toggleQuestionSelect(item.question.id, $event.target.checked)"
                />
              </td>
              <td>{{ item.question.id }}</td>
              <td>{{ typeText(item.question.type) }}</td>
              <td>{{ difficultyText(item.question.difficulty) }}</td>
              <td>{{ item.question.score }}</td>
              <td class="title-cell">{{ item.question.title }}</td>
              <td v-if="isAdmin">{{ item.bankName || '-' }}</td>
              <td v-if="isAdmin">{{ item.bankCreatorName || '-' }}</td>
              <td v-if="isAdmin">{{ Number(item.bankIsPrivate) === 1 ? '私密' : '公开' }}</td>
              <td>{{ (item.tags || []).join(', ') }}</td>
              <td>
                <button class="btn btn-sm btn-light me-2" @click="editQuestion(item)">编辑</button>
                <button class="btn btn-sm btn-danger" @click="deleteQuestion(item.question.id)">删除</button>
              </td>
            </tr>
            <tr v-if="questions.length === 0">
              <td :colspan="isAdmin ? 11 : 8" class="text-muted">暂无题目，请调整筛选条件或新建题目</td>
            </tr>
          </tbody>
        </table>
        <div class="d-flex flex-wrap justify-content-end align-items-center gap-2 mt-3">
          <button type="button" class="btn btn-sm btn-light" :disabled="questionPage <= 0 || questionLoading" @click="goQuestionPage(0)">
            首页
          </button>
          <button
            type="button"
            class="btn btn-sm btn-light"
            :disabled="questionPage <= 0 || questionLoading"
            @click="goQuestionPage(questionPage - 1)"
          >
            上一页
          </button>
          <span class="small text-muted">{{ questionPage + 1 }} / {{ questionTotalPages }}</span>
          <button
            type="button"
            class="btn btn-sm btn-light"
            :disabled="questionPage >= questionTotalPages - 1 || questionLoading"
            @click="goQuestionPage(questionPage + 1)"
          >
            下一页
          </button>
          <button
            type="button"
            class="btn btn-sm btn-light"
            :disabled="questionPage >= questionTotalPages - 1 || questionLoading"
            @click="goQuestionPage(questionTotalPages - 1)"
          >
            末页
          </button>
        </div>
      </div>
    </section>
    </main>

    <div v-if="showQuestionEditModal" class="modal-mask" @click.self="closeQuestionEditModal">
      <div class="modal-panel modal-wide">
        <h5 class="mb-3">编辑题目</h5>
        <div class="row g-2">
          <div class="col-md-4">
            <label class="form-label">题库</label>
            <select v-model.number="editingQuestion.bankId" class="form-select">
              <option :value="null">选择题库</option>
              <option v-for="b in banks" :key="b.id" :value="b.id">{{ b.bankName }}</option>
            </select>
          </div>
          <div class="col-md-4">
            <label class="form-label">题型</label>
            <select v-model="editingQuestion.type" class="form-select" @change="onEditModalQuestionTypeChange">
              <option value="radio">单选</option>
              <option value="multiple">多选</option>
              <option value="judge">判断</option>
              <option value="fill">填空</option>
              <option value="essay">简答</option>
              <option value="coding">编程题</option>
              <option value="material_collect">资料收集题</option>
              <option value="scratch">Scratch编程题</option>
            </select>
          </div>
          <div class="col-md-4">
            <label class="form-label">难度</label>
            <select v-model="editingQuestion.difficulty" class="form-select">
              <option value="easy">易</option>
              <option value="middle">中</option>
              <option value="hard">难</option>
            </select>
          </div>
          <div class="col-md-12">
            <label class="form-label">题干</label>
            <textarea v-model="editingQuestion.title" class="form-control" rows="6" placeholder="题干（支持换行，与学生端展示一致）"></textarea>
          </div>
          <div class="col-md-12">
            <div class="qimg-block rounded p-2 mb-2" style="background: rgba(255, 255, 255, 0.55); border: 1px solid #dfe9ff">
              <div class="d-flex align-items-center gap-2 flex-wrap mb-2">
                <span class="form-label mb-0 fw-semibold">题干附图</span>
                <label class="btn btn-sm btn-outline-secondary mb-0">
                  上传图片
                  <input type="file" class="d-none" accept=".jpg,.jpeg,.png,.gif,image/*" @change="onEditModalStemUpload" />
                </label>
                <span class="small text-muted">jpg/png/gif，≤5MB</span>
              </div>
              <div class="d-flex flex-wrap gap-2 align-items-start">
                <div v-for="(u, idx) in editingQuestion.contentImages || []" :key="'eq-stem-' + idx" class="qimg-tile text-center">
                  <img :src="u" class="teacher-q-thumb" alt="" @click="teachImgLightboxUrl = u" />
                  <div class="d-flex gap-2 justify-content-center align-items-center flex-wrap">
                    <label class="btn btn-link btn-sm p-0 mb-0">
                      更换图片
                      <input type="file" class="d-none" accept=".jpg,.jpeg,.png,.gif,image/*" @change="(e) => onEditModalStemReplace(e, idx)" />
                    </label>
                    <button type="button" class="btn btn-link btn-sm p-0 text-danger" @click="editingQuestion.contentImages.splice(idx, 1)">移除</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="isEditModalChoiceType(editingQuestion.type)" class="col-md-12">
            <label class="form-label">选项 A（支持换行）</label>
            <textarea v-model="editingChoiceOptions.A" class="form-control mb-2" rows="3"></textarea>
            <label class="form-label">选项 B（支持换行）</label>
            <textarea v-model="editingChoiceOptions.B" class="form-control mb-2" rows="3"></textarea>
            <label class="form-label">选项 C（支持换行）</label>
            <textarea v-model="editingChoiceOptions.C" class="form-control mb-2" rows="3"></textarea>
            <label class="form-label">选项 D（支持换行）</label>
            <textarea v-model="editingChoiceOptions.D" class="form-control mb-2" rows="3"></textarea>
          </div>
          <div v-if="isEditModalChoiceType(editingQuestion.type)" class="col-md-12">
            <div class="small fw-semibold mb-2">选项附图</div>
            <div class="row g-2">
              <div class="col-md-6" v-for="optKey of editModalOptionLetters" :key="'eq-opt-' + optKey">
                <div class="small text-muted mb-1">选项 {{ optKey }}</div>
                <div class="d-flex align-items-center gap-2 flex-wrap">
                  <label class="btn btn-sm btn-outline-secondary mb-0">
                    上传/更换
                    <input type="file" class="d-none" accept=".jpg,.jpeg,.png,.gif,image/*" @change="(e) => onEditModalOptImg(e, optKey)" />
                  </label>
                  <template v-if="editModalOptionImg(optKey)">
                    <img :src="editModalOptionImg(optKey)" class="teacher-q-thumb" alt="" @click="teachImgLightboxUrl = editModalOptionImg(optKey)" />
                    <button type="button" class="btn btn-link btn-sm p-0 text-danger" @click="editModalClearOptionImg(optKey)">清除</button>
                  </template>
                </div>
              </div>
            </div>
          </div>
          <div v-if="editingQuestion.type === 'radio'" class="col-md-12">
            <label class="form-label">正确答案</label>
            <select v-model="editingModalSingleAnswer" class="form-select">
              <option value="A">A</option>
              <option value="B">B</option>
              <option value="C">C</option>
              <option value="D">D</option>
            </select>
          </div>
          <div v-if="editingQuestion.type === 'multiple'" class="col-md-12">
            <label class="form-label">正确答案（可多选）</label>
            <div class="d-flex gap-3 flex-wrap">
              <label class="form-check-label"><input v-model="editingModalMultipleAnswers" class="form-check-input me-1" type="checkbox" value="A" />A</label>
              <label class="form-check-label"><input v-model="editingModalMultipleAnswers" class="form-check-input me-1" type="checkbox" value="B" />B</label>
              <label class="form-check-label"><input v-model="editingModalMultipleAnswers" class="form-check-input me-1" type="checkbox" value="C" />C</label>
              <label class="form-check-label"><input v-model="editingModalMultipleAnswers" class="form-check-input me-1" type="checkbox" value="D" />D</label>
            </div>
          </div>
          <div v-if="editingQuestion.type === 'coding'" class="col-md-12">
            <label class="form-label">参考答案（参考解代码）</label>
            <textarea v-model="editingQuestion.answer" class="form-control mb-2 font-monospace" rows="5" placeholder="请输入参考 Python 代码"></textarea>
            <CodingTestCaseEditor
              v-model="editingCodingConfig"
              :reference-code="editingQuestion.answer"
              :validating="codingValidateBusy"
              :validate-message="codingValidateMessage"
              :validate-ok="codingValidateOk"
              @validate="validateCodingCases(true)"
            />
          </div>
          <div v-if="editingQuestion.type === 'fill'" class="col-md-12">
            <label class="form-label">参考答案（多个空请用 || 分隔）</label>
            <textarea v-model="editingQuestion.answer" class="form-control mb-2" rows="3" placeholder="例如：光合作用||叶绿体"></textarea>
            <label class="form-label">判分说明（可选）</label>
            <textarea v-model="editingQuestion.options" class="form-control" rows="2" placeholder="同义词、大小写规则等"></textarea>
          </div>
          <div v-if="editingQuestion.type === 'essay'" class="col-md-12">
            <label class="form-label">参考要点 / 采分点</label>
            <textarea v-model="editingQuestion.answer" class="form-control mb-2" rows="4" placeholder="例如：定义、原因、举例"></textarea>
            <label class="form-label">评分标准（可选）</label>
            <textarea v-model="editingQuestion.options" class="form-control" rows="3" placeholder="分档说明等"></textarea>
          </div>
          <div v-if="editingQuestion.type === 'material_collect'" class="col-md-12">
            <label class="form-label">允许学生上传附件的最大数量</label>
            <input v-model.number="editingMaterialMaxAttachments" type="number" min="1" :max="MATERIAL_MAX_ATTACHMENT_COUNT" class="form-control mb-2" />
            <p class="small text-muted mb-0">
              交卷时学生须填写说明并上传恰好该数量的附件。单文件 ≤10MB；格式：jpg/png/jpeg/gif、pdf、word、zip、rar。
            </p>
          </div>
          <div v-if="editingQuestion.type === 'scratch'" class="col-md-12">
            <p class="small text-muted mb-2">「解析」框填写<strong>任务要求</strong>（学生端展示）。</p>
            <div class="form-check mb-1">
              <input id="e-sc-sprite" v-model="scratchAllowNewSprites" class="form-check-input" type="checkbox" />
              <label class="form-check-label" for="e-sc-sprite">允许学生新增角色</label>
            </div>
            <div class="form-check mb-1">
              <input id="e-sc-back" v-model="scratchAllowNewBackdrops" class="form-check-input" type="checkbox" />
              <label class="form-check-label" for="e-sc-back">允许学生新增背景</label>
            </div>
            <div class="form-check mb-1">
              <input id="e-sc-lib" v-model="scratchAllowMaterialsLibrary" class="form-check-input" type="checkbox" />
              <label class="form-check-label" for="e-sc-lib">允许使用素材库</label>
            </div>
            <div class="form-check mb-0">
              <input id="e-sc-empty" v-model="scratchEmptyProjectDefault" class="form-check-input" type="checkbox" />
              <label class="form-check-label" for="e-sc-empty">默认加载空项目</label>
            </div>
          </div>
          <div v-if="editModalGenericAnswerFields" class="col-md-12">
            <label class="form-label">选项或说明（可选）</label>
            <textarea v-model="editingQuestion.options" class="form-control mb-2" rows="2" placeholder="判断题等可填写选项说明；不需要可留空"></textarea>
            <label class="form-label">参考答案</label>
            <textarea v-model="editingQuestion.answer" class="form-control" rows="2" placeholder="正确答案或标准表述"></textarea>
          </div>
          <div class="col-md-12">
            <label class="form-label">{{ editingQuestion.type === 'scratch' ? '任务要求' : '解析' }}</label>
            <textarea v-model="editingQuestion.analysis" class="form-control" rows="2"></textarea>
          </div>
          <div class="col-md-12">
            <div class="qimg-block rounded p-2 mb-2" style="background: rgba(255, 255, 255, 0.55); border: 1px solid #dfe9ff">
              <div class="d-flex align-items-center gap-2 flex-wrap mb-2">
                <span class="form-label mb-0 fw-semibold">解析附图</span>
                <label class="btn btn-sm btn-outline-secondary mb-0">
                  上传图片
                  <input type="file" class="d-none" accept=".jpg,.jpeg,.png,.gif,image/*" @change="onEditModalAnalysisUpload" />
                </label>
              </div>
              <div class="d-flex flex-wrap gap-2 align-items-start">
                <div v-for="(u, j) in editingQuestion.analysisImages || []" :key="'eq-ana-' + j" class="qimg-tile text-center">
                  <img :src="u" class="teacher-q-thumb" alt="" @click="teachImgLightboxUrl = u" />
                  <div class="d-flex gap-2 justify-content-center align-items-center flex-wrap">
                    <label class="btn btn-link btn-sm p-0 mb-0">
                      更换图片
                      <input type="file" class="d-none" accept=".jpg,.jpeg,.png,.gif,image/*" @change="(e) => onEditModalAnalysisReplace(e, j)" />
                    </label>
                    <button type="button" class="btn btn-link btn-sm p-0 text-danger" @click="editingQuestion.analysisImages.splice(j, 1)">移除</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <label class="form-label">分值</label>
            <input v-model.number="editingQuestion.score" type="number" class="form-control" />
          </div>
          <div class="col-md-9">
            <label class="form-label">标签</label>
            <div class="d-flex flex-wrap gap-2 modal-tag-list">
              <label class="badge bg-secondary p-2" v-for="t in tags" :key="`edit-${t.id}`">
                <input type="checkbox" class="form-check-input me-1" :value="t.id" v-model="editingQuestion.tagIds" />
                {{ t.tagName }}
              </label>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-end gap-2 mt-3">
          <button class="btn btn-light" @click="closeQuestionEditModal">取消</button>
          <button class="btn btn-primary" @click="saveQuestionEdit">保存修改</button>
        </div>
      </div>
    </div>

    <div v-if="teachImgLightboxUrl" class="modal-mask" style="z-index: 1400" @click.self="teachImgLightboxUrl = null">
      <div class="bg-white p-3 rounded shadow-lg" style="max-width: min(96vw, 900px)" @click.stop>
        <div class="d-flex justify-content-between mb-2">
          <span class="small text-muted">点击背景关闭</span>
          <button type="button" class="btn btn-sm btn-outline-secondary" @click="teachImgLightboxUrl = null">关闭</button>
        </div>
        <img :src="teachImgLightboxUrl" alt="预览" style="max-width: 100%; height: auto; max-height: 80vh; object-fit: contain" />
      </div>
    </div>
  </div>
</template>

<script>
import { parseUrlList } from '../utils/questionRichMedia'
import { appConfirm } from '../utils/appDialog'
import { parseMaxAttachments, MATERIAL_MAX_ATTACHMENT_COUNT } from '../utils/materialCollect'
import { defaultScratchOptions } from '../utils/scratchExam'
import { defaultCodingConfig, parseCodingOptions, serializeCodingOptions } from '../utils/codingJudge'
import CodingTestCaseEditor from '../components/CodingTestCaseEditor.vue'

export default {
  name: 'TeacherQuestionManageView',
  components: { CodingTestCaseEditor },
  props: {
    embedded: { type: Boolean, default: false }
  },
  data() {
    return {
      currentUser: {},
      banks: [],
      bankCreators: [],
      tags: [],
      questions: [],
      questionFilters: {
        keyword: '',
        type: '',
        difficulty: '',
        bankId: '',
        tagId: '',
        creatorId: '',
        isPrivate: ''
      },
      questionPage: 0,
      questionPageSize: 10,
      questionTotalPages: 1,
      questionTotalElements: 0,
      questionLoading: false,
      selectedQuestionIds: [],
      batchDeleting: false,
      sidebarCollapsed: false,
      editingId: null,
      showQuestionEditModal: false,
      teachImgLightboxUrl: null,
      batchImportResult: null,
      embeddedImportBusy: false,
      embeddedImportProgress: '',
      zipImportBusy: false,
      zipImportProgress: '',
      zipImportExcel: null,
      zipImportZip: null,
      bankForm: { bankName: '', sort: 0, isPrivate: 0 },
      tagForm: { tagName: '' },
      editingQuestion: {
        bankId: null,
        type: 'radio',
        title: '',
        options: '',
        answer: '',
        analysis: '',
        difficulty: 'middle',
        score: 5,
        tagIds: [],
        contentImages: [],
        analysisImages: [],
        optionAImage: '',
        optionBImage: '',
        optionCImage: '',
        optionDImage: ''
      },
      questionForm: {
        bankId: null,
        type: 'radio',
        title: '',
        options: '',
        answer: '',
        analysis: '',
        difficulty: 'middle',
        score: 5,
        tagIds: [],
        contentImages: [],
        analysisImages: [],
        optionAImage: '',
        optionBImage: '',
        optionCImage: '',
        optionDImage: ''
      },
      questionSingleOptions: { A: '', B: '', C: '', D: '' },
      questionSingleAnswer: 'A',
      questionMultipleAnswers: [],
      editingChoiceOptions: { A: '', B: '', C: '', D: '' },
      editingModalSingleAnswer: 'A',
      editingModalMultipleAnswers: [],
      materialMaxAttachments: 1,
      editingMaterialMaxAttachments: 1,
      MATERIAL_MAX_ATTACHMENT_COUNT,
      scratchAllowNewSprites: true,
      scratchAllowNewBackdrops: true,
      scratchAllowMaterialsLibrary: true,
      scratchEmptyProjectDefault: true,
      codingFormConfig: defaultCodingConfig(),
      editingCodingConfig: defaultCodingConfig(),
      codingValidateBusy: false,
      codingValidateMessage: '',
      codingValidateOk: false
    }
  },
  computed: {
    isAdmin() {
      return String((this.currentUser && this.currentUser.role) || '').toLowerCase() === 'admin'
    },
    pageTitle() {
      if (this.embedded || this.isAdmin) return '题库管理'
      return '教师端 - 题库管理'
    },
    editModalOptionLetters() {
      return ['A', 'B', 'C', 'D']
    },
    editModalGenericAnswerFields() {
      const t = String(this.editingQuestion.type || '').toLowerCase()
      return !['radio', 'multiple', 'coding', 'fill', 'essay', 'material_collect', 'scratch'].includes(t)
    },
    currentPageQuestionIds() {
      return (this.questions || [])
        .map((item) => item && item.question && Number(item.question.id))
        .filter((id) => Number.isFinite(id))
    },
    allCurrentPageSelected() {
      const ids = this.currentPageQuestionIds
      return ids.length > 0 && ids.every((id) => this.selectedQuestionIds.includes(id))
    },
    someCurrentPageSelected() {
      const ids = this.currentPageQuestionIds
      return ids.some((id) => this.selectedQuestionIds.includes(id))
    }
  },
  created() {
    try {
      this.currentUser = JSON.parse(localStorage.getItem('exam_user') || '{}')
    } catch (e) {
      this.currentUser = {}
    }
    this.loadAll()
  },
  methods: {
    authHeaders(extra = {}) {
      let role = 'teacher'
      let userId = ''
      try {
        const u = JSON.parse(localStorage.getItem('exam_user') || '{}')
        role = u.role || 'teacher'
        userId = u.id != null ? String(u.id) : ''
      } catch (e) {
        role = 'teacher'
      }
      return {
        'X-Role': role,
        'X-User-Id': userId,
        'X-CSRF-Token': role === 'admin' ? 'exam-ui' : 'teacher-ui',
        ...extra
      }
    },
    goPaperManage() {
      localStorage.setItem('teacher_active_menu', 'paper')
      window.location.hash = '#/teacher/papers'
    },
    goExamManage() {
      localStorage.setItem('teacher_active_menu', 'exam')
      window.location.hash = '#/teacher/papers'
    },
    goGradingManage() {
      localStorage.setItem('teacher_active_menu', 'grading')
      window.location.hash = '#/teacher/papers'
    },
    goExamRecordManage() {
      window.location.hash = '#/teacher/exam-records'
    },
    goProctor() {
      window.location.hash = '#/teacher/proctor'
    },
    goStudentUsers() {
      window.location.hash = '#/teacher/students'
    },
    toggleSidebar() {
      this.sidebarCollapsed = !this.sidebarCollapsed
    },
    logout() {
      localStorage.removeItem('exam_user')
      window.location.hash = '#/'
    },
    loadAll() {
      this.loadBanks()
      this.loadTags()
      if (this.isAdmin) this.loadBankCreators()
      this.loadQuestions()
    },
    loadBanks() {
      const params = new URLSearchParams({ page: '0', size: '200' })
      fetch(`/api/teacher/question/banks?${params.toString()}`, {
        headers: this.authHeaders()
      })
        .then((r) => r.json())
        .then((res) => {
          this.banks = (res.data && res.data.content) || []
        })
    },
    loadBankCreators() {
      fetch('/api/teacher/question/banks/creators', { headers: this.authHeaders() })
        .then((r) => r.json())
        .then((res) => {
          this.bankCreators = Array.isArray(res.data) ? res.data : []
        })
        .catch(() => {
          this.bankCreators = []
        })
    },
    saveBank() {
      const payload = {
        bankName: this.bankForm.bankName,
        sort: this.bankForm.sort
      }
      if (this.isAdmin) {
        payload.isPrivate = Number(this.bankForm.isPrivate) === 1 ? 1 : 0
      }
      fetch('/api/teacher/question/banks', {
        method: 'POST',
        headers: this.authHeaders({ 'Content-Type': 'application/json' }),
        body: JSON.stringify(payload)
      })
        .then((r) => r.json())
        .then((res) => {
          if (res.code === 200) {
            this.bankForm = { bankName: '', sort: 0, isPrivate: 0 }
            this.loadBanks()
          } else {
            window.alert(res.message || '保存失败')
          }
        })
    },
    async toggleBankPrivate(b) {
      if (!this.isAdmin || !b || !b.id) return
      const next = Number(b.isPrivate) === 1 ? 0 : 1
      const r = await fetch('/api/teacher/question/banks', {
        method: 'POST',
        headers: this.authHeaders({ 'Content-Type': 'application/json' }),
        body: JSON.stringify({
          id: b.id,
          bankName: b.bankName,
          sort: b.sort || 0,
          isPrivate: next
        })
      })
      const res = await r.json().catch(() => ({}))
      if (res.code !== 200) {
        window.alert(res.message || '设置失败')
        return
      }
      this.loadBanks()
    },
    async deleteBank(id) {
      if (!(await appConfirm('确认删除该题库吗？若题库下仍有题目可能受影响，请谨慎操作。'))) return
      try {
        const r = await fetch(`/api/teacher/question/banks/${id}`, {
          method: 'DELETE',
          headers: this.authHeaders()
        })
        const res = await r.json().catch(() => ({}))
        if (!r.ok || (res && res.code !== undefined && res.code !== 200)) {
          window.alert((res && res.message) || `删除失败（HTTP ${r.status}）`)
          return
        }
        window.alert('删除成功')
        this.loadBanks()
      } catch (e) {
        window.alert('删除失败，请检查网络后重试')
      }
    },
    loadTags() {
      fetch('/api/teacher/question/tags', {
        headers: this.authHeaders()
      })
        .then((r) => r.json())
        .then((res) => {
          this.tags = res.data || []
        })
    },
    saveTag() {
      fetch('/api/teacher/question/tags', {
        method: 'POST',
        headers: this.authHeaders({ 'Content-Type': 'application/json' }),
        body: JSON.stringify(this.tagForm)
      })
        .then((r) => r.json())
        .then((res) => {
          if (res.code === 200) {
            this.tagForm = { tagName: '' }
            this.loadTags()
          } else {
            window.alert(res.message || '保存失败')
          }
        })
    },
    async deleteTag(id) {
      if (!(await appConfirm('确认删除该标签吗？'))) return
      try {
        const r = await fetch(`/api/teacher/question/tags/${id}`, {
          method: 'DELETE',
          headers: this.authHeaders()
        })
        const res = await r.json().catch(() => ({}))
        if (!r.ok || (res && res.code !== undefined && res.code !== 200)) {
          window.alert((res && res.message) || `删除失败（HTTP ${r.status}）`)
          return
        }
        window.alert('删除成功')
        this.loadTags()
      } catch (e) {
        window.alert('删除失败，请检查网络后重试')
      }
    },
    loadQuestions() {
      this.questionLoading = true
      const params = new URLSearchParams({
        page: String(this.questionPage || 0),
        size: String(this.questionPageSize || 10)
      })
      const f = this.questionFilters || {}
      if (f.keyword) params.append('keyword', String(f.keyword).trim())
      if (f.type) params.append('type', String(f.type).trim())
      if (f.difficulty) params.append('difficulty', String(f.difficulty).trim())
      if (f.bankId !== '' && f.bankId != null) params.append('bankId', String(f.bankId))
      if (f.tagId !== '' && f.tagId != null) params.append('tagId', String(f.tagId))
      if (this.isAdmin && f.creatorId !== '' && f.creatorId != null) params.append('creatorId', String(f.creatorId))
      if (this.isAdmin && f.isPrivate !== '' && f.isPrivate != null) params.append('isPrivate', String(f.isPrivate))

      fetch(`/api/teacher/question/questions?${params.toString()}`, {
        headers: this.authHeaders()
      })
        .then(async (r) => {
          const res = await r.json().catch(() => ({}))
          if (!r.ok || res.code !== 200) {
            window.alert((res && res.message) || '加载题目失败')
            this.questions = []
            this.questionTotalElements = 0
            this.questionTotalPages = 1
            return
          }
          const page = res.data || {}
          this.questions = page.content || []
          this.questionTotalElements = Number(page.totalElements || 0)
          let tp = page.totalPages != null ? Number(page.totalPages) : 1
          if (!Number.isFinite(tp) || tp < 1) tp = 1
          this.questionTotalPages = tp
          if (this.questionPage > tp - 1) {
            this.questionPage = Math.max(0, tp - 1)
          }
        })
        .catch(() => {
          window.alert('加载题目失败，请检查网络后重试')
          this.questions = []
        })
        .finally(() => {
          this.questionLoading = false
        })
    },
    toggleQuestionSelect(id, checked) {
      const qid = Number(id)
      if (!Number.isFinite(qid)) return
      if (checked) {
        if (!this.selectedQuestionIds.includes(qid)) {
          this.selectedQuestionIds = [...this.selectedQuestionIds, qid]
        }
      } else {
        this.selectedQuestionIds = this.selectedQuestionIds.filter((x) => x !== qid)
      }
    },
    toggleSelectAllCurrentPage(checked) {
      const pageIds = this.currentPageQuestionIds.map((id) => Number(id)).filter((id) => Number.isFinite(id))
      if (checked) {
        const set = new Set(this.selectedQuestionIds)
        pageIds.forEach((id) => set.add(id))
        this.selectedQuestionIds = [...set]
      } else {
        const remove = new Set(pageIds)
        this.selectedQuestionIds = this.selectedQuestionIds.filter((id) => !remove.has(id))
      }
    },
    async batchDeleteQuestions() {
      const ids = [...this.selectedQuestionIds]
      if (!ids.length) {
        window.alert('请先勾选要删除的题目')
        return
      }
      if (!(await appConfirm(`确认批量删除选中的 ${ids.length} 道题目吗？此操作不可恢复。`))) return
      this.batchDeleting = true
      try {
        const r = await fetch('/api/teacher/question/questions/batch-delete', {
          method: 'POST',
          headers: this.authHeaders({ 'Content-Type': 'application/json' }),
          body: JSON.stringify({ ids })
        })
        const res = await r.json().catch(() => ({}))
        if (!r.ok || (res && res.code !== undefined && res.code !== 200)) {
          window.alert((res && res.message) || `批量删除失败（HTTP ${r.status}）`)
          return
        }
        const deleted = (res.data && res.data.deleted) != null ? res.data.deleted : ids.length
        window.alert(`已删除 ${deleted} 道题目`)
        this.selectedQuestionIds = []
        if (this.questions.length <= deleted && this.questionPage > 0) {
          this.questionPage -= 1
        }
        this.loadQuestions()
      } catch (e) {
        window.alert('批量删除失败，请检查网络后重试')
      } finally {
        this.batchDeleting = false
      }
    },
    searchQuestions() {
      this.questionPage = 0
      this.selectedQuestionIds = []
      this.loadQuestions()
    },
    resetQuestionFilters() {
      this.questionFilters = {
        keyword: '',
        type: '',
        difficulty: '',
        bankId: '',
        tagId: '',
        creatorId: '',
        isPrivate: ''
      }
      this.selectedQuestionIds = []
      this.searchQuestions()
    },
    goQuestionPage(next) {
      const page = Number(next)
      if (!Number.isFinite(page) || page < 0) return
      if (page === this.questionPage) return
      if (page >= this.questionTotalPages) return
      this.questionPage = page
      this.loadQuestions()
    },
    onQuestionTypeChange() {
      if (this.questionForm.type === 'radio') {
        this.questionForm.options = ''
        this.questionForm.answer = this.questionSingleAnswer || 'A'
        return
      }
      if (this.questionForm.type === 'multiple') {
        this.questionForm.options = ''
        this.questionForm.answer = (this.questionMultipleAnswers || []).slice().sort().join(',')
        return
      }
      if (this.questionForm.type === 'material_collect') {
        let n = Math.floor(Number(this.materialMaxAttachments) || 1)
        if (n < 1) n = 1
        if (n > MATERIAL_MAX_ATTACHMENT_COUNT) n = MATERIAL_MAX_ATTACHMENT_COUNT
        this.materialMaxAttachments = n
        this.questionForm.options = JSON.stringify({ maxAttachments: n })
        this.questionForm.answer = '{}'
      }
      if (this.questionForm.type === 'scratch') {
        this.applyScratchDefaults()
        this.questionForm.options = this.buildScratchOptionsJson()
        this.questionForm.answer = '{}'
      }
    },
    typeText(type) {
      const t = String(type || '').toLowerCase()
      if (t === 'radio') return '单选'
      if (t === 'multiple') return '多选'
      if (t === 'judge') return '判断'
      if (t === 'fill') return '填空'
      if (t === 'essay') return '简答'
      if (t === 'coding') return '编程题'
      if (t === 'material_collect') return '资料收集'
      if (t === 'scratch') return 'Scratch编程'
      return type || '-'
    },
    difficultyText(difficulty) {
      const d = String(difficulty || '').toLowerCase()
      if (d === 'easy') return '简单'
      if (d === 'middle') return '中等'
      if (d === 'hard') return '困难'
      return difficulty || '-'
    },
    buildQuestionPayload() {
      const payload = { ...this.questionForm }
      if (payload.type === 'radio') {
        payload.options = JSON.stringify({
          A: String(this.questionSingleOptions.A || ''),
          B: String(this.questionSingleOptions.B || ''),
          C: String(this.questionSingleOptions.C || ''),
          D: String(this.questionSingleOptions.D || '')
        })
        payload.answer = String(this.questionSingleAnswer || 'A')
      } else if (payload.type === 'multiple') {
        payload.options = JSON.stringify({
          A: String(this.questionSingleOptions.A || ''),
          B: String(this.questionSingleOptions.B || ''),
          C: String(this.questionSingleOptions.C || ''),
          D: String(this.questionSingleOptions.D || '')
        })
        payload.answer = (this.questionMultipleAnswers || [])
          .map((x) => String(x || '').trim().toUpperCase())
          .filter((x) => x === 'A' || x === 'B' || x === 'C' || x === 'D')
          .sort()
          .join(',')
      } else if (payload.type === 'material_collect') {
        let n = Math.floor(Number(this.materialMaxAttachments) || 1)
        if (n < 1) n = 1
        if (n > MATERIAL_MAX_ATTACHMENT_COUNT) n = MATERIAL_MAX_ATTACHMENT_COUNT
        payload.options = JSON.stringify({ maxAttachments: n })
        payload.answer = '{}'
      } else if (payload.type === 'scratch') {
        payload.options = this.buildScratchOptionsJson()
        payload.answer = '{}'
      } else if (payload.type === 'coding') {
        payload.options = serializeCodingOptions(this.codingFormConfig)
      }
      return payload
    },
    validateCodingCases(fromEditModal) {
      const referenceCode = fromEditModal
        ? String(this.editingQuestion.answer || '').trim()
        : String(this.questionForm.answer || '').trim()
      const options = fromEditModal
        ? serializeCodingOptions(this.editingCodingConfig)
        : serializeCodingOptions(this.codingFormConfig)
      if (!referenceCode) {
        this.codingValidateOk = false
        this.codingValidateMessage = '请先填写参考解代码'
        return Promise.resolve(false)
      }
      this.codingValidateBusy = true
      this.codingValidateMessage = ''
      this.codingValidateOk = false
      return fetch('/api/teacher/question/questions/validate-cases', {
        method: 'POST',
        headers: this.authHeaders({ 'Content-Type': 'application/json' }),
        body: JSON.stringify({ options, referenceCode })
      })
        .then((r) => r.json())
        .then((res) => {
          if (res.code === 200) {
            this.codingValidateOk = true
            this.codingValidateMessage = res.message || '全部用例校验通过'
            return true
          }
          this.codingValidateOk = false
          this.codingValidateMessage = res.message || '用例校验失败'
          return false
        })
        .catch(() => {
          this.codingValidateOk = false
          this.codingValidateMessage = '校验请求失败'
          return false
        })
        .finally(() => {
          this.codingValidateBusy = false
        })
    },
    saveQuestion() {
      const method = this.editingId ? 'PUT' : 'POST'
      const url = this.editingId
        ? `/api/teacher/question/questions/${this.editingId}`
        : '/api/teacher/question/questions'
      const payload = this.buildQuestionPayload()
      const doSave = () => {
        fetch(url, {
          method,
          headers: this.authHeaders({ 'Content-Type': 'application/json' }),
          body: JSON.stringify(payload)
        })
          .then((r) => r.json())
          .then((res) => {
            if (res.code === 200) {
              this.resetQuestionForm()
              this.loadQuestions()
            } else {
              window.alert(res.message || '保存失败')
            }
          })
      }
      if (payload.type === 'coding' && (this.codingFormConfig.testCases || []).length > 0) {
        this.validateCodingCases(false).then((ok) => {
          if (ok) doSave()
        })
        return
      }
      doSave()
    },
    editQuestion(item) {
      this.editingId = item.question.id
      const selectedTagIds = this.tags
        .filter((t) => (item.tags || []).includes(t.tagName))
        .map((t) => t.id)
      const stemList = parseUrlList(item.question.contentImages)
      const anaList = parseUrlList(item.question.analysisImages)
      this.editingQuestion = {
        bankId: item.question.bankId,
        type: item.question.type,
        title: item.question.title,
        options: item.question.options || '',
        answer: item.question.answer || '',
        analysis: item.question.analysis || '',
        difficulty: item.question.difficulty || 'middle',
        score: item.question.score || 0,
        tagIds: selectedTagIds,
        contentImages: stemList,
        analysisImages: anaList,
        optionAImage: item.question.optionAImage || '',
        optionBImage: item.question.optionBImage || '',
        optionCImage: item.question.optionCImage || '',
        optionDImage: item.question.optionDImage || ''
      }
      this.editingChoiceOptions = this.parseChoiceOptionsForEdit(item.question.options || '')
      const typ = String(item.question.type || '').toLowerCase()
      if (typ === 'radio') {
        const a = String(item.question.answer || 'A').trim().toUpperCase()
        this.editingModalSingleAnswer = ['A', 'B', 'C', 'D'].includes(a) ? a : 'A'
        this.editingModalMultipleAnswers = []
      } else if (typ === 'multiple') {
        this.editingModalMultipleAnswers = String(item.question.answer || '')
          .split(',')
          .map((x) => String(x || '').trim().toUpperCase())
          .filter((x) => ['A', 'B', 'C', 'D'].includes(x))
        this.editingModalSingleAnswer = 'A'
      } else {
        this.editingModalSingleAnswer = 'A'
        this.editingModalMultipleAnswers = []
      }
      if (typ === 'material_collect') {
        this.editingMaterialMaxAttachments = parseMaxAttachments({ options: item.question.options })
      } else {
        this.editingMaterialMaxAttachments = 1
      }
      if (typ === 'scratch') {
        this.applyScratchOptionsFromJson(item.question.options || '')
      } else {
        this.applyScratchDefaults()
      }
      if (typ === 'coding') {
        this.editingCodingConfig = parseCodingOptions(item.question.options || '')
      } else {
        this.editingCodingConfig = defaultCodingConfig()
      }
      this.codingValidateMessage = ''
      this.codingValidateOk = false
      this.showQuestionEditModal = true
    },
    parseChoiceOptionsForEdit(raw) {
      const empty = { A: '', B: '', C: '', D: '' }
      if (!raw) return { ...empty }
      try {
        const obj = JSON.parse(raw)
        if (Array.isArray(obj)) {
          return {
            A: String(obj[0] || ''),
            B: String(obj[1] || ''),
            C: String(obj[2] || ''),
            D: String(obj[3] || '')
          }
        }
        if (obj && typeof obj === 'object') {
          return {
            A: String(obj.A || obj.a || ''),
            B: String(obj.B || obj.b || ''),
            C: String(obj.C || obj.c || ''),
            D: String(obj.D || obj.d || '')
          }
        }
      } catch (e) {
        const lines = String(raw).split('\n')
        return {
          A: String(lines[0] || ''),
          B: String(lines[1] || ''),
          C: String(lines[2] || ''),
          D: String(lines[3] || '')
        }
      }
      return { ...empty }
    },
    onEditModalQuestionTypeChange() {
      const t = String(this.editingQuestion.type || '').toLowerCase()
      if (t === 'scratch') {
        this.applyScratchOptionsFromJson(this.editingQuestion.options || '')
      }
      if (t === 'material_collect') {
        this.editingMaterialMaxAttachments = parseMaxAttachments({ options: this.editingQuestion.options })
      }
      if (t === 'radio' || t === 'multiple') {
        this.editingChoiceOptions = this.parseChoiceOptionsForEdit(this.editingQuestion.options || '')
      }
      if (t === 'radio') {
        const a = String(this.editingQuestion.answer || 'A').trim().toUpperCase()
        this.editingModalSingleAnswer = ['A', 'B', 'C', 'D'].includes(a) ? a : 'A'
      }
      if (t === 'multiple') {
        this.editingModalMultipleAnswers = String(this.editingQuestion.answer || '')
          .split(',')
          .map((x) => String(x || '').trim().toUpperCase())
          .filter((x) => ['A', 'B', 'C', 'D'].includes(x))
      }
    },
    editModalOptionImg(key) {
      const k = String(key || '').toUpperCase()
      const e = this.editingQuestion
      if (!e) return ''
      if (k === 'A') return e.optionAImage || ''
      if (k === 'B') return e.optionBImage || ''
      if (k === 'C') return e.optionCImage || ''
      if (k === 'D') return e.optionDImage || ''
      return ''
    },
    editModalClearOptionImg(key) {
      const k = String(key || '').toUpperCase()
      if (k === 'A') this.editingQuestion.optionAImage = ''
      else if (k === 'B') this.editingQuestion.optionBImage = ''
      else if (k === 'C') this.editingQuestion.optionCImage = ''
      else if (k === 'D') this.editingQuestion.optionDImage = ''
    },
    buildEditingQuestionPayload() {
      const e = this.editingQuestion
      const stem = Array.isArray(e.contentImages) ? e.contentImages.map((x) => String(x || '').trim()).filter(Boolean) : []
      const ana = Array.isArray(e.analysisImages) ? e.analysisImages.map((x) => String(x || '').trim()).filter(Boolean) : []
      const typ = String(e.type || '').toLowerCase()
      const base = {
        bankId: e.bankId,
        type: e.type,
        title: e.title,
        analysis: e.analysis,
        difficulty: e.difficulty,
        score: e.score,
        tagIds: Array.isArray(e.tagIds) ? e.tagIds : [],
        contentImages: stem,
        analysisImages: ana,
        optionAImage: e.optionAImage ? String(e.optionAImage).trim() : '',
        optionBImage: e.optionBImage ? String(e.optionBImage).trim() : '',
        optionCImage: e.optionCImage ? String(e.optionCImage).trim() : '',
        optionDImage: e.optionDImage ? String(e.optionDImage).trim() : ''
      }
      if (typ === 'radio') {
        return {
          ...base,
          options: JSON.stringify({
            A: String(this.editingChoiceOptions.A || ''),
            B: String(this.editingChoiceOptions.B || ''),
            C: String(this.editingChoiceOptions.C || ''),
            D: String(this.editingChoiceOptions.D || '')
          }),
          answer: String(this.editingModalSingleAnswer || 'A')
        }
      }
      if (typ === 'multiple') {
        return {
          ...base,
          options: JSON.stringify({
            A: String(this.editingChoiceOptions.A || ''),
            B: String(this.editingChoiceOptions.B || ''),
            C: String(this.editingChoiceOptions.C || ''),
            D: String(this.editingChoiceOptions.D || '')
          }),
          answer: (this.editingModalMultipleAnswers || [])
            .map((x) => String(x || '').trim().toUpperCase())
            .filter((x) => ['A', 'B', 'C', 'D'].includes(x))
            .sort()
            .join(',')
        }
      }
      if (typ === 'material_collect') {
        let n = Math.floor(Number(this.editingMaterialMaxAttachments) || 1)
        if (n < 1) n = 1
        if (n > MATERIAL_MAX_ATTACHMENT_COUNT) n = MATERIAL_MAX_ATTACHMENT_COUNT
        return {
          ...base,
          options: JSON.stringify({ maxAttachments: n }),
          answer: '{}'
        }
      }
      if (typ === 'scratch') {
        return {
          ...base,
          options: this.buildScratchOptionsJson(),
          answer: '{}'
        }
      }
      if (typ === 'coding') {
        return {
          ...base,
          options: serializeCodingOptions(this.editingCodingConfig),
          answer: e.answer || ''
        }
      }
      return {
        ...base,
        options: e.options || '',
        answer: e.answer || ''
      }
    },
    closeQuestionEditModal() {
      this.showQuestionEditModal = false
    },
    isEditModalChoiceType(type) {
      const t = String(type || '').toLowerCase()
      return t === 'radio' || t === 'multiple'
    },
    saveQuestionEdit() {
      if (!this.editingId) return
      const body = this.buildEditingQuestionPayload()
      const doSave = () => {
        fetch(`/api/teacher/question/questions/${this.editingId}`, {
          method: 'PUT',
          headers: this.authHeaders({ 'Content-Type': 'application/json' }),
          body: JSON.stringify(body)
        })
          .then((r) => r.json())
          .then((res) => {
            if (res.code === 200) {
              this.showQuestionEditModal = false
              this.loadQuestions()
              return
            }
            window.alert(res.message || '保存失败')
          })
      }
      if (body.type === 'coding' && (this.editingCodingConfig.testCases || []).length > 0) {
        this.validateCodingCases(true).then((ok) => {
          if (ok) doSave()
        })
        return
      }
      doSave()
    },
    async deleteQuestion(id) {
      if (!(await appConfirm(`确认删除题目 ID ${id} 吗？`))) return
      try {
        const r = await fetch(`/api/teacher/question/questions/${id}`, {
          method: 'DELETE',
          headers: this.authHeaders()
        })
        const res = await r.json().catch(() => ({}))
        if (!r.ok || (res && res.code !== undefined && res.code !== 200)) {
          window.alert((res && res.message) || `删除失败（HTTP ${r.status}）`)
          return
        }
        window.alert('删除成功')
        this.selectedQuestionIds = this.selectedQuestionIds.filter((x) => x !== Number(id))
        if (this.questions.length <= 1 && this.questionPage > 0) {
          this.questionPage -= 1
        }
        this.loadQuestions()
      } catch (e) {
        window.alert('删除失败，请检查网络后重试')
      }
    },
    resetQuestionForm() {
      this.editingId = null
      this.questionForm = {
        bankId: null,
        type: 'radio',
        title: '',
        options: '',
        answer: '',
        analysis: '',
        difficulty: 'middle',
        score: 5,
        tagIds: [],
        contentImages: [],
        analysisImages: [],
        optionAImage: '',
        optionBImage: '',
        optionCImage: '',
        optionDImage: ''
      }
      this.questionSingleOptions = { A: '', B: '', C: '', D: '' }
      this.questionSingleAnswer = 'A'
      this.questionMultipleAnswers = []
      this.materialMaxAttachments = 1
      this.applyScratchDefaults()
      this.codingFormConfig = defaultCodingConfig()
      this.codingValidateMessage = ''
      this.codingValidateOk = false
    },
    applyScratchDefaults() {
      const d = defaultScratchOptions()
      this.scratchAllowNewSprites = d.allowNewSprites
      this.scratchAllowNewBackdrops = d.allowNewBackdrops
      this.scratchAllowMaterialsLibrary = d.allowMaterialsLibrary
      this.scratchEmptyProjectDefault = d.emptyProjectDefault
    },
    applyScratchOptionsFromJson(raw) {
      this.applyScratchDefaults()
      if (!raw || !String(raw).trim()) return
      try {
        const o = JSON.parse(raw)
        if (o && typeof o === 'object') {
          if (typeof o.allowNewSprites === 'boolean') this.scratchAllowNewSprites = o.allowNewSprites
          if (typeof o.allowNewBackdrops === 'boolean') this.scratchAllowNewBackdrops = o.allowNewBackdrops
          if (typeof o.allowMaterialsLibrary === 'boolean') this.scratchAllowMaterialsLibrary = o.allowMaterialsLibrary
          if (typeof o.emptyProjectDefault === 'boolean') this.scratchEmptyProjectDefault = o.emptyProjectDefault
        }
      } catch (e) {
        void e
      }
    },
    buildScratchOptionsJson() {
      return JSON.stringify({
        allowNewSprites: !!this.scratchAllowNewSprites,
        allowNewBackdrops: !!this.scratchAllowNewBackdrops,
        allowMaterialsLibrary: !!this.scratchAllowMaterialsLibrary,
        emptyProjectDefault: !!this.scratchEmptyProjectDefault
      })
    },
    exportExcel() {
      fetch('/api/teacher/question/questions/export', {
        headers: this.authHeaders()
      })
        .then((r) => r.blob())
        .then((blob) => {
          const url = window.URL.createObjectURL(blob)
          const a = document.createElement('a')
          a.href = url
          a.download = 'questions.xlsx'
          a.click()
          window.URL.revokeObjectURL(url)
        })
    },
    downloadImportTemplate() {
      fetch('/api/teacher/question/questions/template', {
        headers: this.authHeaders()
      })
        .then((r) => {
          if (!r.ok) {
            throw new Error(`HTTP ${r.status}`)
          }
          return r.blob()
        })
        .then((blob) => {
          const url = window.URL.createObjectURL(blob)
          const a = document.createElement('a')
          a.href = url
          a.download = 'questions_import_template.xlsx'
          a.click()
          window.URL.revokeObjectURL(url)
        })
        .catch((e) => {
          window.alert(`下载模板失败：${(e && e.message) || '请检查后端服务是否启动'}`)
        })
    },
    importExcel(e) {
      const file = e.target.files && e.target.files[0]
      if (e.target) e.target.value = ''
      if (!file) return
      const form = new FormData()
      form.append('file', file)
      fetch('/api/teacher/question/questions/import', {
        method: 'POST',
        headers: this.authHeaders(),
        body: form
      })
        .then((r) => r.json())
        .then((res) => {
          window.alert(res.data || res.message || '导入完成')
          this.loadQuestions()
        })
    },
    parseImgRaw(raw) {
      const t = String(raw || '').trim()
      if (!t) return []
      if (t.startsWith('[')) return parseUrlList(t)
      return t.split(/\r?\n/)
        .map((x) => x.trim())
        .filter(Boolean)
    },
    async teacherPostImage(file) {
      if (!file) return null
      if (file.size > 5 * 1024 * 1024) {
        window.alert('单张图片不能超过 5MB')
        return null
      }
      const fd = new FormData()
      fd.append('file', file)
      const r = await fetch('/api/teacher/question/questions/images/upload', {
        method: 'POST',
        headers: this.authHeaders(),
        body: fd
      })
      const j = await r.json()
      if (j.code !== 200 || !j.data || !j.data.url) {
        window.alert(j.message || '上传失败')
        return null
      }
      return j.data.url
    },
    async onTeacherUploadStem(ev) {
      const f = ev.target.files && ev.target.files[0]
      if (ev.target) ev.target.value = ''
      if (!f) return
      const url = await this.teacherPostImage(f)
      if (url) this.questionForm.contentImages.push(url)
    },
    async onTeacherUploadAnalysis(ev) {
      const f = ev.target.files && ev.target.files[0]
      if (ev.target) ev.target.value = ''
      if (!f) return
      const url = await this.teacherPostImage(f)
      if (url) this.questionForm.analysisImages.push(url)
    },
    async onTeacherOptImg(ev, key) {
      const f = ev.target.files && ev.target.files[0]
      if (ev.target) ev.target.value = ''
      if (!f) return
      const url = await this.teacherPostImage(f)
      if (!url) return
      const prop = `option${key}Image`
      this.questionForm[prop] = url
    },
    async onEditModalStemUpload(ev) {
      const f = ev.target.files && ev.target.files[0]
      if (ev.target) ev.target.value = ''
      if (!f) return
      const url = await this.teacherPostImage(f)
      if (!url) return
      if (!Array.isArray(this.editingQuestion.contentImages)) this.editingQuestion.contentImages = []
      this.editingQuestion.contentImages.push(url)
    },
    async onEditModalStemReplace(ev, idx) {
      const f = ev.target.files && ev.target.files[0]
      if (ev.target) ev.target.value = ''
      if (!f) return
      const url = await this.teacherPostImage(f)
      if (!url || !Array.isArray(this.editingQuestion.contentImages)) return
      this.editingQuestion.contentImages.splice(Number(idx), 1, url)
    },
    async onEditModalAnalysisUpload(ev) {
      const f = ev.target.files && ev.target.files[0]
      if (ev.target) ev.target.value = ''
      if (!f) return
      const url = await this.teacherPostImage(f)
      if (!url) return
      if (!Array.isArray(this.editingQuestion.analysisImages)) this.editingQuestion.analysisImages = []
      this.editingQuestion.analysisImages.push(url)
    },
    async onEditModalAnalysisReplace(ev, idx) {
      const f = ev.target.files && ev.target.files[0]
      if (ev.target) ev.target.value = ''
      if (!f) return
      const url = await this.teacherPostImage(f)
      if (!url || !Array.isArray(this.editingQuestion.analysisImages)) return
      this.editingQuestion.analysisImages.splice(Number(idx), 1, url)
    },
    async onEditModalOptImg(ev, key) {
      const f = ev.target.files && ev.target.files[0]
      if (ev.target) ev.target.value = ''
      if (!f) return
      const url = await this.teacherPostImage(f)
      if (!url) return
      const k = String(key || '').toUpperCase()
      if (k === 'A') this.editingQuestion.optionAImage = url
      else if (k === 'B') this.editingQuestion.optionBImage = url
      else if (k === 'C') this.editingQuestion.optionCImage = url
      else if (k === 'D') this.editingQuestion.optionDImage = url
    },
    downloadEmbeddedExcelTemplate() {
      fetch('/api/teacher/question/questions/import-excel-embedded-template', {
        headers: this.authHeaders()
      })
        .then((r) => {
          if (!r.ok) throw new Error(`HTTP ${r.status}`)
          return r.blob()
        })
        .then((blob) => {
          const url = window.URL.createObjectURL(blob)
          const a = document.createElement('a')
          a.href = url
          a.download = 'questions_embedded_images_template.xlsx'
          a.click()
          window.URL.revokeObjectURL(url)
        })
        .catch((e) => {
          window.alert(`下载失败：${(e && e.message) || '请检查后端'}`)
        })
    },
    submitEmbeddedExcelImport(ev) {
      const f = ev.target.files && ev.target.files[0]
      if (ev.target) ev.target.value = ''
      if (!f) return
      if (!f.name.toLowerCase().endsWith('.xlsx')) {
        window.alert('请上传 .xlsx 文件')
        return
      }
      this.embeddedImportBusy = true
      this.embeddedImportProgress = '正在上传文件…'
      const msgs = ['正在解析工作表…', '正在提取嵌入式图片…', '正在写入题库…']
      let mi = 0
      const tick = window.setInterval(() => {
        if (mi < msgs.length) {
          this.embeddedImportProgress = msgs[mi++]
        }
      }, 700)
      const fd = new FormData()
      fd.append('file', f)
      fetch('/api/teacher/question/questions/import-excel-embedded', {
        method: 'POST',
        headers: this.authHeaders(),
        body: fd
      })
        .then((r) => r.json())
        .then((res) => {
          window.clearInterval(tick)
          this.embeddedImportBusy = false
          this.embeddedImportProgress = ''
          if (res.code === 200) {
            this.batchImportResult = res.data || null
            this.loadQuestions()
            window.alert(res.message || '导入完成')
            return
          }
          window.alert(res.message || '导入失败')
        })
        .catch((e) => {
          window.clearInterval(tick)
          this.embeddedImportBusy = false
          this.embeddedImportProgress = ''
          window.alert(`导入异常：${(e && e.message) || e}`)
        })
    },
    downloadImageZipTemplate() {
      fetch('/api/teacher/question/questions/import-image-template', {
        headers: this.authHeaders()
      })
        .then((r) => {
          if (!r.ok) throw new Error(`HTTP ${r.status}`)
          return r.blob()
        })
        .then((blob) => {
          const url = window.URL.createObjectURL(blob)
          const a = document.createElement('a')
          a.href = url
          a.download = 'questions_import_with_images_template.xlsx'
          a.click()
          window.URL.revokeObjectURL(url)
        })
        .catch((e) => {
          window.alert(`下载失败：${(e && e.message) || '请检查后端'}`)
        })
    },
    onZipImportExcelPick(ev) {
      const f = ev.target.files && ev.target.files[0]
      if (ev.target) ev.target.value = ''
      this.zipImportExcel = f || null
    },
    onZipImportZipPick(ev) {
      const f = ev.target.files && ev.target.files[0]
      if (ev.target) ev.target.value = ''
      this.zipImportZip = f || null
    },
    submitZipImport() {
      if (!this.zipImportExcel || !this.zipImportZip) {
        window.alert('请先选择 Excel 和 ZIP 文件')
        return
      }
      this.zipImportBusy = true
      this.zipImportProgress = '正在上传并解析…'
      const fd = new FormData()
      fd.append('excel', this.zipImportExcel)
      fd.append('zip', this.zipImportZip)
      fetch('/api/teacher/question/questions/import-with-images', {
        method: 'POST',
        headers: this.authHeaders(),
        body: fd
      })
        .then((r) => r.json())
        .then((res) => {
          this.zipImportBusy = false
          this.zipImportProgress = ''
          if (res.code === 200) {
            this.batchImportResult = res.data || null
            this.loadQuestions()
            this.zipImportExcel = null
            this.zipImportZip = null
            window.alert(res.message || '导入完成')
            return
          }
          window.alert(res.message || '导入失败')
        })
        .catch((e) => {
          this.zipImportBusy = false
          this.zipImportProgress = ''
          window.alert(`导入异常：${(e && e.message) || e}`)
        })
    }
  }
}
</script>

<style scoped>
.teacher-page {
  min-height: 100vh;
  padding: 20px;
  background:
    radial-gradient(circle at 8% 10%, rgba(82, 149, 255, 0.16), transparent 34%),
    radial-gradient(circle at 92% 20%, rgba(120, 170, 255, 0.14), transparent 30%),
    linear-gradient(160deg, #f7faff 0%, #eef4ff 55%, #f8fbff 100%);
  color: #1f2a44;
}
.question-manage-embedded {
  min-height: 0;
  padding: 0;
  background: transparent;
}
.question-manage-embedded-main {
  width: 100%;
  min-width: 0;
}

.side-nav {
  width: 240px;
  min-height: calc(100vh - 40px);
  margin-right: 16px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  background: rgba(255, 255, 255, 0.78);
  border: 1px solid #d8e6ff;
  border-radius: 12px;
  box-shadow: 0 12px 30px rgba(63, 108, 199, 0.1);
  backdrop-filter: blur(8px);
  flex-shrink: 0;
}

.side-nav.collapsed {
  width: 76px;
}

.side-nav.collapsed .nav-text {
  display: none;
}

.side-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 4px;
}

.collapse-btn {
  width: 28px;
  height: 28px;
  border-radius: 8px;
  border: 1px solid #d8e6ff;
  background: #f6f9ff;
  color: #335896;
  font-size: 12px;
}

.sub-btn {
  border: 1px solid #d8e6ff;
  border-radius: 10px;
  padding: 10px 12px;
  color: #335896;
  background: #f6f9ff;
  text-align: left;
  transition: all 0.2s ease;
}

.sub-btn:hover {
  background: #eef5ff;
  border-color: #bfd6ff;
  transform: translateY(-1px);
}

.sub-btn.active {
  background: linear-gradient(120deg, #2f6feb, #5ca2ff);
  color: #ffffff;
  border-color: transparent;
}

.content-area {
  flex: 1;
}

.topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  padding: 14px 16px;
  border-radius: 12px;
  background: linear-gradient(165deg, rgba(255, 255, 255, 0.82), rgba(245, 250, 255, 0.92));
  border: 1px solid #d8e6ff;
  box-shadow: 0 10px 26px rgba(48, 96, 192, 0.1);
}

.card-box {
  background: linear-gradient(165deg, rgba(255, 255, 255, 0.82), rgba(245, 250, 255, 0.92));
  border: 1px solid #d8e6ff;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 16px;
  box-shadow: 0 10px 26px rgba(48, 96, 192, 0.1);
}

.result-shell {
  border: 1px solid rgba(145, 180, 240, 0.35);
  border-radius: 12px;
  padding: 8px;
  background: linear-gradient(165deg, rgba(255, 255, 255, 0.82), rgba(245, 250, 255, 0.92));
}

.question-filter-bar {
  padding: 10px 12px;
  margin: 0 0 10px;
  border: 1px solid #d7e6ff;
  border-radius: 12px;
  background: linear-gradient(180deg, #f7fbff 0%, #eef5ff 100%);
}

.card-box h4,
.card-box h5 {
  color: #1f2a44;
  font-weight: 700;
}

.table :deep(th),
.table :deep(td) {
  vertical-align: middle;
}

.btn {
  border-radius: 10px;
  font-weight: 600;
}

.modal-mask {
  position: fixed;
  inset: 0;
  background: rgba(18, 36, 76, 0.35);
  backdrop-filter: blur(3px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  z-index: 1200;
}

.modal-panel {
  width: min(920px, 100%);
  max-height: calc(100vh - 40px);
  overflow: auto;
  background: linear-gradient(165deg, rgba(255, 255, 255, 0.96), rgba(244, 250, 255, 0.98));
  border: 1px solid #d8e6ff;
  border-radius: 16px;
  padding: 18px;
  box-shadow: 0 20px 50px rgba(35, 72, 150, 0.22);
}

.modal-panel.modal-wide {
  width: min(1080px, 100%);
}

.modal-tag-list {
  max-height: 120px;
  overflow: auto;
  padding: 4px;
}

@media (max-width: 992px) {
  .teacher-page {
    flex-direction: column;
  }

  .side-nav {
    width: 100%;
    min-height: auto;
    margin-right: 0;
    margin-bottom: 12px;
  }
}

.actions {
  display: flex;
  gap: 8px;
}

.mini-close {
  transform: scale(0.7);
}

.title-cell {
  max-width: 280px;
  white-space: pre-wrap;
  word-break: break-word;
}

.teacher-q-thumb {
  max-width: min(100%, 600px);
  height: auto;
  object-fit: contain;
  border-radius: 8px;
  border: 1px solid #c5d6f5;
  cursor: zoom-in;
}

.qimg-tile {
  max-width: 620px;
}
</style>
